<p>spotlight-menu-item works!</p>
